module.exports = __webpack_public_path__ + "static/media/ibm.b3fc3749.svg";